export const constants = {
  version: "0.9.1",
  name: "Minecraft Creator Tools",
  disclaimer: "Alpha software. License at https://github.com/mojang/minecraft-creator-tools.",
  copyright: "Copyright 2024 Mojang AB. All rights reserved.",
  homeUrl: "https://mctools.dev",
  repositoryUrl: "https://github.com/mojang/minecraft-creator-tools",
};
